import { defineStore } from 'pinia';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import { useProjectStore } from './projectStore';

export const useInvoiceStore = defineStore('invoice', {
  state: () => ({
    invoices: [],
    invoicesLoading: false,
  }),

  actions: {
    async getInvoices() {
      this.invoicesLoading = true;
      try {
        const projectStore = useProjectStore();
        const invoices = await window.appConnector.getInvoices(projectStore.projectIdSelected);
        this.invoices = invoices;
        this.invoicesLoading = false;
      } catch (error) {
        this.invoicesLoading = false;
        if (error?.status === 404) {
          return;
        }
        notificationWrapper();
        throw error;
      }
    },
    async handleDownload(invoiceId: string) {
      try {
        const projectStore = useProjectStore();
        const response = await window.appConnector.getInvoiceDownloadUrl(projectStore.projectIdSelected, invoiceId);
        if (typeof response?.download_url === 'string') {
          return response.download_url;
        }
        if (response?.download_url !== null) {
          throw new TypeError('Invoice download URL is missing');
        }

        const download = await window.appConnector.getInvoiceDownload(projectStore.projectIdSelected, invoiceId);
        if (!(download.data instanceof Blob)) {
          throw new TypeError('Invoice download did not return a Blob');
        }

        return download.data;
      } catch (error) {
        notificationWrapper();
        throw error;
      }
    },
  },
});
